import React, { Component } from "react";
import ImageButtonList from "../common/imageButtonList";
import ImageBackground from "../common/imageBackground";
import ImageHeader from "../common/imageHeader";
import NavigationBar from "../common/navigationBar";

export default class PainLevel extends Component {
  header = {
    id: 'header',
    src: require('./images/1333_elements.png')
  };
  buttonList = {
    top: 112,
    left: 130,
    width: 1045,
    height: 490
  };
  buttons = [
    {
      id: 'face0',
      to: '/pain_monitoring/thankyou',
      unhighlight: require('./images/face_0.png'),
      highlight: require('./images/face0_HL.png'),
      alt: ''
    },
    {
      id: 'face2',
      to: '/pain_monitoring/thankyou',
      unhighlight: require('./images/face_2.png'),
      highlight: require('./images/face2_HL.png'),
      alt: ''
    },
    {
      id: 'face4',
      to: '/pain_monitoring/thankyou',
      unhighlight: require('./images/face_4.png'),
      highlight: require('./images/face4_HL.png'),
      alt: ''
    },
    {
      id: 'face6',
      to: '/pain_monitoring/thankyou',
      unhighlight: require('./images/face_6.png'),
      highlight: require('./images/face6_HL.png'),
      alt: ''
    },
    {
      id: 'face8',
      to: '/pain_monitoring/thankyou',
      unhighlight: require('./images/face_8.png'),
      highlight: require('./images/face8_HL.png'),
      alt: ''
    },
    {
      id: 'face10',
      to: '/pain_monitoring/thankyou',
      unhighlight: require('./images/face_10.png'),
      highlight: require('./images/face10_HL.png'),
      alt: ''
    }
  ];
  navigationBar = {
    mainMenu: false,
    back: false,
    backRoute: '/main_menu'
  };
  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1333">
        <ImageBackground id="background" />
        <ImageHeader {...this.header} />
        <ImageButtonList {...this.buttonList} imageButtons={this.buttons} flexClass="flex-horizontal" />
        <NavigationBar {...this.navigationBar} />
      </div>
    );
  }
}
